export default function Logo({ size = 40, withText = true, subtitle = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="rcscw-logo">
      <img
        src="/rcscw-logo.png"
        alt="RCSCW crest"
        className="shrink-0 object-contain"
        style={{ height: size, width: "auto", maxWidth: size * 1.2 }}
      />
      {withText && (
        <div className="leading-none">
          <div className="font-mono text-sm tracking-[0.3em] text-silver">RCSCW</div>
          {subtitle && <div className="mt-1 font-mono text-[9px] tracking-[0.22em] text-silver-muted">2026 — 27</div>}
        </div>
      )}
    </div>
  );
}
